export default {"src":"/_next/static/media/TW.d370164f.svg","height":34,"width":50,"blurWidth":0,"blurHeight":0};